import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import getCategoryFilters from 'store/category/selector/getCategoryFilters';
import getCategoryId from 'store/category/selector/getCategoryId';
import getCategoryPageNr from 'store/category/selector/getCategoryPageNr';
import getCategorySortBy from 'store/category/selector/getCategorySortBy';
import isFiltersEmpty from 'utils/family/isFiltersEmpty';
import prepareCategoryFilters from 'utils/family/prepareCategoryFilters';
import { numberToSortAlg } from 'utils/family/sortAlgMapping';
import getDefaultSortOrderByCategoryId from 'utils/getDefaultSortOrderByCategoryId';
import composeCategoryPageParams from 'utils/routes/composeCategoryPageParams';

const undefinedForDefault = (value: any, defaultValue: any) => (value === defaultValue ? undefined : value);

const useCategoryURLParams = (forcePageNr?: number) => {
  const pageNr = forcePageNr || useSelector(getCategoryPageNr);
  const sortBy = useSelector(getCategorySortBy);
  const filters = prepareCategoryFilters(useSelector(getCategoryFilters));
  const location = useLocation();
  const categoryId = useSelector(getCategoryId);
  const defaultSortOrder = getDefaultSortOrderByCategoryId(categoryId || 1);

  return {
    queryString:
      composeCategoryPageParams(
        undefinedForDefault(pageNr, 1),
        numberToSortAlg(undefinedForDefault(sortBy, defaultSortOrder)),
        isFiltersEmpty(filters) ? undefined : filters,
      ) || location.pathname,
  };
};

export default useCategoryURLParams;
